<template>
  <div>
    <span v-if="!enableEdit">
      <div class="row border-bottom">
        <div class="input-left col-lg-3 col-4">
          <label>
            登入密碼
          </label>
        </div>
        <div class="col-lg-9 col-8 pl-2">
          <div class="row">
            <div class="col-lg-9 col-10"
                    :class="{'col-12': !enableEdit}">
              <AGCInput name="密碼"
                        value="abcd"
                        required
                        disabled
                        type="password"
              ></AGCInput>
            </div>
          </div>
        </div>
      </div>
    </span>
    <span v-if="enableEdit">
      <div class="row border-bottom">
        <div class="input-left col-lg-3 col-4">
          <label>
            舊密碼
          </label>
        </div>
        <div class="col-lg-9 col-8 pl-2">
          <div class="row">
            <div class="col-lg-9 col-10"
                    :class="{'col-12': !enableEdit}">
              <AGCInput v-model="inputVal.oldPassword"
                        type="password"
                        name="舊密碼"
                        :rules=checkOldPassword
                        required
              ></AGCInput>
            </div>
          </div>
        </div>
      </div>
      <div class="row border-bottom">
        <div class="input-left col-lg-3 col-4">
          <label>
            新密碼
          </label>
        </div>
        <div class="col-lg-9 col-8 pl-2">
          <div class="row">
            <div class="col-lg-9 col-10"
                    :class="{'col-12': !enableEdit}">
              <AGCInput v-model="inputVal.newPassword"
                        type="password"
                        vid="password"
                        name="新密碼"
                        :rules=checkNewPassword
                        required
              ></AGCInput>
            </div>
          </div>
        </div>
      </div>
      <div class="row border-bottom">
        <div class="input-left col-lg-3 col-4">
          <label>
            確認新密碼
          </label>
        </div>
        <div class="col-lg-9 col-8 pl-2">
          <div class="row">
            <div class="col-lg-9 col-10"
                    :class="{'col-12': !enableEdit}">
              <AGCInput v-model="inputVal.confirmNewPassword"
                        type="password"
                        name="確認新密碼"
                        :rules=checkConfirmNewPassword
                        required
              ></AGCInput>
            </div>
          </div>
        </div>
      </div>
    </span>
  </div>
</template>

<script>
import AGCInput from './AGCInput.vue';
import agcFormElementMixin from '../../mixins/agc-form-element';

export default {
  mixins: [agcFormElementMixin],
  components: {
    AGCInput,
  },
  computed: {
    checkOldPassword() {
      if (this.inputVal.oldPassword || this.inputVal.newPassword
          || this.inputVal.confirmNewPassword) {
        return 'required';
      }
      return '';
    },
    checkNewPassword() {
      if (this.inputVal.oldPassword || this.inputVal.newPassword
          || this.inputVal.confirmNewPassword) {
        return 'required|password';
      }
      return '';
    },
    checkConfirmNewPassword() {
      if (this.inputVal.oldPassword || this.inputVal.newPassword
          || this.inputVal.confirmNewPassword) {
        return 'required|confirmed:password';
      }
      return '';
    },
  },
};
</script>
